import PritingAPI from "tools/printing";

const URI = "http://localhost:7001";
const pritingAPI = new PritingAPI(URI);
//

async function printOrder(props) {
  let { data_order, data_invoice, ctx } = props;
  await pritingAPI.post("/print_invoice", {
    context: ctx,
    record: data_invoice,
  });
  await pritingAPI.post("/print_order", { context: ctx, orders: data_order });
}

export default printOrder;
